import axiosInstance from '../axiosInterceptor/axiosInstance'

const getGameResult = async ({ orgId, gameId }) => {
  const url = `v1/orgs/${orgId}/games/${gameId}/stats/result`
  const response = await axiosInstance.get(url, { skipErrorNotification: true })
  return response?.data
}

export default getGameResult
